export default __webpack_public_path__ + "img/9504df24a6bd4956e9ad830f8e45c66c.png";